<template>
    <el-table
        class="contact-pane"
        border
        style="width: 100%"
        :data="contact"
        header-row-class-name="contact-header-row"
        cell-class-name="contact-cell"
    >
        <el-table-column prop="contacter" label="联系人姓名" width="376"> </el-table-column>
        <el-table-column prop="contacter_email" label="联系人邮箱"> </el-table-column>
        <el-table-column prop="contacter_phone" label="联系人电话"> </el-table-column>
    </el-table>
</template>
<script>
export default {
    name: 'DetailContactPane',
    props: {
        contact: {
            type: Array
        }
    }
};
</script>
<style lang="less" scoped>
.contact-pane {
    /deep/ .contact-header-row {
        color: #303133;
        height: 68px;
    }
    /deep/ .contact-cell {
        height: 68px;
    }
}
</style>
